import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const RunsRoutes: RouteBundle = {
  domain: 'runs',
  routes: [
    {
      urlPattern: 'assay-runs/:runId',
      handler: EditorRoutes.runEditor.bind(EditorRoutes),
      legacy: false,
    },
  ],
};
